/* eslint-disable react/prop-types */
import React, {useState, useEffect} from 'react';
import {Link} from 'react-router-dom';
import {ArrowLeftOutlined} from '@ant-design/icons';

import Table from '../../components/ui/Table';
import {dealsTableConfig} from './config/dealsTableConfig';
import {DealActions} from '../../actions';
import {notify} from '../../components/ui/Toast/Toast';

const BilledDealsPage = ({
    handleMissionNavigation,
    userData
}) => {

    // States locaux pour cette page
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [paginationMetadata, setPaginationMetadata] = useState({
        totalItems: 0,
        currentPage: 1,
        pageSize: 30
    });
    const [filterQuery, setFilterQuery] = useState('');

    // Fonction de fetch locale
    const fetchData = async (page) => {
        setLoading(true);
        setData([]);

        try {
            const result = await DealActions.getAllDeals(
                userData,
                `&type=business&page_size=${paginationMetadata.pageSize}&status=700${filterQuery}`,
                page || paginationMetadata.currentPage,
            );

            if (result.success) {
                setData(result.data);
                setPaginationMetadata(prevState => ({...prevState, currentPage: page}));

                if (paginationMetadata.totalItems !== result.metadata.count) {
                    setPaginationMetadata(prevState => ({...prevState, totalItems: result.metadata.count}));
                }
            }
            else {
                notify('Une erreur est survenue lors de la récuperation de la liste des affaires facturées');
            }
        } catch {
            notify('Une erreur est survenue lors de la récuperation de la liste des affaires facturées');
        }

        setLoading(false);
    };

    // Fonction de filtre locale
    const filterDealList = async (query) => {
        setFilterQuery(`&${query}`);
    };

    // Effet pour fetch initial et lors des changements de filtre
    useEffect(() => {
        fetchData(1);
    }, [filterQuery]);

    const tableConfig = dealsTableConfig('billed', handleMissionNavigation, userData, filterDealList);

    return (
        <>
            <div className='flex items-center justify-between my-10'>
                <Link to='/dashboard/office-manager'>
                    <ArrowLeftOutlined style={{fontSize: '25px'}}/>
                </Link>
                <h1
                    className='text-3xl font-bold'
                    style={{fontFamily: 'DIN Condensed'}}
                >
                    {`Facturée (${paginationMetadata.totalItems})`}
                </h1>
                <div/>
            </div>

            <Table
                data={data}
                tableConfig={tableConfig}
                paginationMetadata={paginationMetadata}
                onPageNumberChange={fetchData}
                loading={loading}
            />
        </>
    )
}

export default BilledDealsPage;